let lastScrollTop = 0;
const header = document.querySelector('#shopify-section-sections--29575500530041__header');

window.addEventListener('scroll', function() {
  let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
  
  if (currentScroll > lastScrollTop) {
    // Scrolling down - Hide the header
    header.classList.add('header-hidden');
  } else {
    // Scrolling up - Show the header
    header.classList.remove('header-hidden');
  }
  
  // For Mobile or negative scrolling
  lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; 
}, false);

//header margin

